import { Link } from "react-router-dom";
import { useSession } from "@jkast90/kast-common/auth";
import MaterialIcon from "@common/components/MaterialIcon";
import { signIn, signOut } from "../session";

export default function AuthMenu() {
  const { status, user } = useSession();

  // Only while a stored session that had expired is refreshed.
  if (status === "loading") return <span className="muted">Checking sign-in…</span>;

  if (status === "signedIn") {
    return (
      <div className="auth">
        <Link
          to="/profile"
          className="btn icon-btn auth-me"
          aria-label="Your profile"
          data-tip={`${user?.name || "You"} · your profile`}
        >
          <MaterialIcon name="account_circle" />
        </Link>
        <button type="button" className="btn icon-btn" aria-label="Sign out" data-tip="Sign out" onClick={() => void signOut()}>
          <MaterialIcon name="logout" />
        </button>
      </div>
    );
  }

  return (
    <button type="button" className="btn" onClick={signIn}>
      Sign in
    </button>
  );
}
